module.exports = __webpack_public_path__ + "img/hospitalization.9f5307ef.svg";